import styled from "styled-components";
import { useState, useEffect } from "react";
import Script from "next/script";

const CoinzillaWrapper = styled.div`
  margin-top: 1.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
  flex-direction: column;

  .coinzilla {
    height: auto !important;
  }
`;

const CoinzillaHorizontal = (id) => {
  const [ssr, setSsr] = useState(true);
  useEffect(() => {
    setSsr(false);
    if (
      typeof window !== "undefined" &&
      !ssr &&
      process.env.NODE_ENV === "production"
    ) {
      const script = document.createElement("script");
      script.src = "https://coinzillatag.com/lib/display.js";
      script.async = true;
      document.body.appendChild(script);
      window.coinzilla_display = window.coinzilla_display || [];
      let c_display_preferences = {};
      c_display_preferences.zone = "505e1faf1d1f234672";
      c_display_preferences.width = "728";
      c_display_preferences.height = "90";
      window.coinzilla_display.push(c_display_preferences);
    }
  }, [ssr]);
  return (
    <CoinzillaWrapper>
      {!ssr && (
        <>
          <div
            className="coinzilla"
            data-zone="C-505e1faf1d1f234672"
            style={{ marginBottom: 16 }}
          />
        </>
      )}
    </CoinzillaWrapper>
  );
};

export default CoinzillaHorizontal;
